/** "1–25 of 132" with previous and next. Renders nothing when everything fits on one page. */
export function Pager({
  page,
  pageSize,
  total,
  onPage,
  noun = 'items',
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  noun?: string;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const go = (p: number) => {
    onPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <nav className="pager" aria-label="Pages">
      <span className="pager-count">
        {from}–{to} of {total} {noun}
      </span>
      <div className="pager-buttons">
        <button type="button" className="pager-button" onClick={() => go(page - 1)} disabled={page <= 1} aria-label="Previous page">
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <span className="pager-page">
          Page {page} of {pages}
        </span>
        <button type="button" className="pager-button" onClick={() => go(page + 1)} disabled={page >= pages} aria-label="Next page">
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </nav>
  );
}
